import React, { useState, useRef, useEffect } from "react";
import styles from "../date.module.css";
import { TextField } from "@mui/material";

export default function YearUI(props) {
  const {
    key_id,
    field,
    title,
    onUpdate,
    onChange,
    enableQuery,
    length = 4,
    placeHolder,
    value_position = "value",
    value_name_position = "value_name",
    item_specific_error_validator,
    setParentFieldError,
    error,
    value,
  } = props;

  const ref = useRef(null);
  const [lengthErrorFlag, setLengthErrorFlag] = useState(false); // used to keep track of if we should flag for error if less than 4

  const onKeyDown = (key) => {
    if (key.keyCode === 13) {
      ref.current.blur();
    }
  };

  const is_error = () => {
    if (value?.length !== 4 && !lengthErrorFlag) {
      //this is used for randomization checking and flogic at the form level
      setParentFieldError && setParentFieldError(key_id, true);
      return false;
    } else {
      let local_validation = () => !/^[1-2]{1}[0-9]{3}$/.test(value);
      let error = local_validation();
      if (item_specific_error_validator && item_specific_error_validator.constructor === Function) {
        error = local_validation() || item_specific_error_validator();
      }

      //this is used for randomization checking and flogic at the form level
      setParentFieldError && setParentFieldError(key_id, error);

      return error;
    }
  };
  const onBlur = () => {
    onUpdate();
  };

  return (
    <React.Fragment>
      <div>
        <div className={styles.input_flex}>
          <div>
            <TextField
              type="text"
              inputRef={ref}
              placeholder=""
              autoComplete="off"
              inputProps={{ maxLength: length }}
              value={value}
              onChange={(e) => {
                if (/^([0-9]+){0,4}$/.test(e.target.value)) {
                  if (e.target.value?.length !== 4) {
                    setLengthErrorFlag(true);
                  } else {
                    setLengthErrorFlag(false);
                  }
                  onChange(e.target.value);
                }
              }}
              onKeyDown={onKeyDown}
              onBlur={onBlur}
              sx={{
                "& .MuiInputBase-input": {
                  padding: "5px",
                  textAlign: "center",
                  width: "50px",
                },
              }}
              error={is_error()}
            />
          </div>
          <div className={styles.input_description}>(YYYY)</div>
        </div>
        {field.value_obj?.missing ? <div className={styles.missing}>missing</div> : null}
      </div>
    </React.Fragment>
  );
}
